import { FromURL } from "@/features/flow/types";
import { cn } from "@/features/utils/cn";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export enum RadioCardButtonSize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM"
}

type RadioCardProps = {
  children?: ReactNode | ReactNode[];
  active: boolean;
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  origin?: FromURL;
  dataCy?: string;
  buttonSize?: RadioCardButtonSize;
};

export const RadioCard = ({
  children,
  onClick,
  className = "",
  active,
  disabled = false,
  origin,
  dataCy,
  buttonSize = RadioCardButtonSize.MEDIUM
}: RadioCardProps) => (
  <div
    data-cy={dataCy}
    className={twMerge(
      "flex w-full flex-row space-x-2 rounded-sm border-2 border-slate-50 px-2 py-4",
      active && !disabled
        ? origin !== FromURL.None
          ? "border-success bg-green-100"
          : "border-primary"
        : "",
      disabled && "select-none opacity-50",
      !disabled && "cursor-pointer",
      className
    )}
    onClick={disabled ? () => {} : onClick}
  >
    <div
      className={cn("flex items-center justify-center rounded-full border-2 border-slate-50", {
        "border-slate-400": active && !disabled && origin !== FromURL.None,
        "border-primary": active && !disabled && origin === FromURL.None,
        "size-6 min-w-6": buttonSize === RadioCardButtonSize.MEDIUM,
        "mt-0.5 size-4 min-w-4": buttonSize === RadioCardButtonSize.SMALL
      })}
    >
      <div
        className={cn(
          "rounded-full",
          active && (origin === FromURL.None ? "bg-primary" : "bg-green-500"),
          buttonSize === RadioCardButtonSize.MEDIUM && "size-3",
          buttonSize === RadioCardButtonSize.SMALL && "size-2"
        )}
      ></div>
    </div>
    <div className={active ? "dark:text-black" : ""}>{children}</div>
  </div>
);
